import { useState, useEffect } from 'react';
import LogoImg from '../../Assets/Img/Logo.png';
import '../LandingPage/LandingPage.css';

function NoticeModal() {
    const [isVisible, setIsVisible] = useState(false);
    const [noticeContent, setNoticeContent] = useState('로딩 중...'); // 깃허브 내용을 담을 상태

    useEffect(() => {
        // 1. 팝업 노출 여부 확인
        const hideUntil = localStorage.getItem('hideNotice');
        const now = new Date().getTime();

        if (!hideUntil || now > parseInt(hideUntil)) {
            setIsVisible(true);

            // 2. 깃허브에서 공지 내용 가져오기
            const fetchNotice = async () => {
                try {
                    // 여기에 복사한 Raw URL을 입력하세요
                    const response = await fetch('https://raw.githubusercontent.com/ChordCon/onpyeong/refs/heads/main/notice.txt');
                    const text = await response.text();
                    setNoticeContent(text);
                } catch (error) {
                    setNoticeContent('공지사항을 불러오는 데 실패했습니다.');
                }
            };

            fetchNotice();
        }
    }, []);

    const renderFormattedText = (text) => {
        return text.split('\n').map((line, index) => {
            // **텍스트** 부분을 찾아서 <strong>으로 치환
            const parts = line.split(/(\*\*.*?\*\*)/g);
            return (
                <span key={index}>
                    {parts.map((part, i) =>
                        part.startsWith('**') && part.endsWith('**')
                            ? <strong key={i}>{part.slice(2, -2)}</strong>
                            : part
                    )}
                    <br />
                </span>
            );
        });
    };

    const hideForToday = () => {
        const tomorrow = new Date();
        tomorrow.setHours(24, 0, 0, 0);
        localStorage.setItem('hideNotice', tomorrow.getTime().toString());
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="modal-overlay">
            <div className="notice-modal-card shadow-lg">
                <div className="notice-header d-flex align-items-center justify-content-center">
                    <img src={LogoImg} alt="로고" className="notice-logo me-2" />
                    <h5 className="fw-bold mb-0">온평에서 전해드리는 소식</h5>
                </div>

                <div className="notice-body p-4">
                    {/* whiteSpace: 'pre-wrap'을 써야 텍스트 파일의 줄바꿈이 유지됩니다 */}
                    <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                        안녕하십니까. 법률사무소 온평입니다.<br />
                        <br />
                        {/* 붉은색 강조 구간 삭제 될 구간 */}
                        <span style={{ color: '#dc3545', fontWeight: '500' }}>
                            현재 해당 사이트의 이미지, 문구는 임의로 작성되었습니다.<br />
                            추후 정식으로 사이트를 운영할 예정입니다.<br />
                            이점 양해 부탁드립니다.<br />
                        </span>
                        <br />
                        {renderFormattedText(noticeContent)}
                        <br />
                        법률사무소 온평을 방문해주셔서 감사합니다.
                    </p>
                </div>

                <div className="notice-footer d-flex border-top">
                    <button className="btn-hide-today w-50 p-3" onClick={hideForToday}>오늘 하루 보지 않기</button>
                    <button className="btn-close-notice w-50 p-3 border-start" onClick={() => setIsVisible(false)}>닫기</button>
                </div>
            </div>
        </div>
    );
}

export default NoticeModal;